import {
  LOCAL_STORAGE_ORDER_STATUS,
  LOCAL_STORAGE_ORDER_STATUS_FAILED_ATTEMPTS,
  ORDER_STATUS_REQUEST,
  ORDER_STATUS_SUCCESS,
  ORDER_STATUS_FAILURE,
  ORDER_STATUS_TRACKING_DATA_REQUEST,
  ORDER_STATUS_TRACKING_DATA_SUCCESS,
  ORDER_STATUS_TRACKING_DATA_FAILURE,
  ORDER_HELP_ACTIONS_REQUEST,
  ORDER_HELP_ACTIONS_SUCCESS,
  ORDER_HELP_ACTIONS_FAILURE,
  ORDER_STATUS_WHATSAPP_REQUEST,
  ORDER_STATUS_WHATSAPP_SUCCESS,
  ORDER_STATUS_WHATSAPP_FAILURE,
  ORDER_STATUS_SHARE_REQUEST,
  ORDER_STATUS_SHARE_SUCCESS,
  ORDER_STATUS_SHARE_FAILURE,
  SET_ORDER_STATUS_SHARED,
  SET_INFO_BANNER_MODAL_IS_OPEN,
} from '../../actions/types';

import getSafe from '../../utils/getSafe';

import {
  createStatus,
  createOrder,
  createTracking,
  createLocation,
  createRider,
  createContactDetails,
  createContactModal,
  createInfoBanner,
  getShouldShowMap,
  createMissedCallModal,
  createOrderConfirmationReference,
  createDirectionHelpAction,
  createOrderStatusFailedAttemptsCount,
} from './factories';

const initialState = {
  error: null,
  failedAttempts: 0,
  loading: false,
  shareModal: {
    error: null,
    loading: false,
  },
};

export default function statusReducer(state = initialState, action = {}) {
  const newAction = Object.assign({}, action);
  let status;
  let order;
  let rider;
  let locations;
  let contactDetails;
  let contact;
  let tracking;
  let infoBanner;
  let sharingToken;
  let sharingEnabled;
  let sharingShortUrl;
  let missedCallModal;
  let orderConfirmationReference;
  let directionHelpAction;

  switch (newAction.type) {
    case ORDER_STATUS_REQUEST:
      /* changing error to null causes order-status to refresh and clears polling */
      return {
        ...state,
        loading: true,
      };
    case LOCAL_STORAGE_ORDER_STATUS:
      if (newAction.payload.data) {
        status = createStatus(newAction.payload.data);
      }
      if (newAction.payload.included) {
        const orderData = newAction.payload.included.find((o) => o.type === 'order');
        if (orderData.attributes) {
          order = createOrder(orderData);
        }
      }

      return {
        ...state,
        ...status,
        order,
      };
    case ORDER_STATUS_SUCCESS: {
      // Response is in JSONAPI format. It is not too complicated to use a
      // JSONAPI deserializer library, hence using factories.

      let showMap = false;
      if (newAction.payload.data) {
        status = createStatus(newAction.payload.data);
      }
      if (newAction.payload.included) {
        const orderData = newAction.payload.included.find((o) => o.type === 'order');
        const infoBannerData = newAction.payload.included.find((o) => o.type === 'info_banner');
        const locationsData = newAction.payload.included.filter((o) => o.type === 'location');
        const riderData = newAction.payload.included.find((o) => o.type === 'rider');
        const contactDetailsData = newAction.payload.included.find(
          (o) => o.type === 'contextual_help_action',
        );
        const missedCallModalData = newAction.payload.included.find(
          (o) => o.type === 'phone_call_modal',
        );
        const orderConfirmationReferenceData = newAction.payload.included.find(
          (o) => o.type === 'order_confirmation_reference',
        );
        const directionHelpActionData = newAction.payload.included.find(
          (o) => o.type === 'direction_help_action',
        );

        if (orderData.attributes) {
          order = createOrder(orderData);
        }
        if (riderData && riderData.attributes) {
          rider = createRider(riderData.attributes);
        }
        if (infoBannerData && infoBannerData.attributes) {
          infoBanner = createInfoBanner(infoBannerData);
        }
        if (contactDetailsData && contactDetailsData.attributes) {
          contactDetails = createContactDetails(contactDetailsData);
        }
        if (locationsData.length) {
          const customerLocation = locationsData.find(
            (location) => location.attributes && location.attributes.type === 'CUSTOMER',
          );
          const riderLocation = locationsData.find(
            (location) => location.attributes && location.attributes.type === 'RIDER',
          );
          const restaurantLocation = locationsData.find(
            (location) => location.attributes && location.attributes.type === 'RESTAURANT',
          );
          locations = [customerLocation, riderLocation, restaurantLocation].filter(
            (location) => !!location,
          );
          locations = locations.map((location) => createLocation(location));
        }
        if (missedCallModalData && missedCallModalData.attributes) {
          missedCallModal = createMissedCallModal(missedCallModalData.attributes);
        }
        if (getSafe(() => orderConfirmationReferenceData.attributes)) {
          orderConfirmationReference = createOrderConfirmationReference(
            orderConfirmationReferenceData.attributes,
          );
        }
        if (getSafe(() => directionHelpActionData.attributes)) {
          directionHelpAction = createDirectionHelpAction(directionHelpActionData.attributes);
        }

        showMap = getShouldShowMap(newAction.payload.data, locationsData, riderData);
      }

      return {
        ...state,
        error: null,
        failedAttempts: 0,
        loading: false,
        ...status,
        order,
        locations,
        rider,
        infoBanner,
        missedCallModal,
        contactDetails: {
          ...state.contactDetails,
          ...contactDetails,
        },
        shareModal: {
          loading: false,
          error: null,
          sharingToken: order.sharingToken,
          sharingShortUrl: order.sharingShortUrl,
        },
        showMap,
        orderConfirmationReference,
        directionHelpAction,
      };
    }
    case ORDER_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        failedAttempts: createOrderStatusFailedAttemptsCount(
          newAction.status,
          state.failedAttempts,
        ),
        error: {
          statusCode: newAction.status,
          message: newAction.message,
        },
      };
    case LOCAL_STORAGE_ORDER_STATUS_FAILED_ATTEMPTS:
      return {
        ...state,
        failedAttempts: state.failedAttempts + action.payload.failedAttempts,
      };
    case SET_ORDER_STATUS_SHARED:
      return {
        ...state,
        isSharedOrder: action.payload.isShared,
      };
    case ORDER_STATUS_SHARE_REQUEST:
      return {
        ...state,
        shareModal: {
          loading: true,
          error: null,
        },
      };
    case ORDER_STATUS_SHARE_SUCCESS:
      if (newAction.payload.included) {
        const orderData = newAction.payload.included.find((o) => o.type === 'order');
        if (orderData.attributes) {
          sharingToken = orderData.attributes.sharing_token;
          sharingEnabled = orderData.attributes.sharing_enabled;
          sharingShortUrl = orderData.attributes.sharing_short_url;
        }
      }

      return {
        ...state,
        shareModal: {
          loading: false,
          error: null,
          sharingToken,
          sharingShortUrl,
        },
        order: {
          ...state.order,
          sharingEnabled,
        },
      };
    case ORDER_STATUS_SHARE_FAILURE:
      return {
        ...state,
        shareModal: {
          loading: false,
          error: {
            statusCode: newAction.status,
            message: newAction.message,
          },
        },
      };
    case ORDER_STATUS_TRACKING_DATA_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case ORDER_STATUS_TRACKING_DATA_SUCCESS:
      if (newAction.payload && newAction.payload.tracking) {
        tracking = createTracking(newAction.payload.tracking);
      }
      return {
        ...state,
        tracking,
      };
    case ORDER_STATUS_TRACKING_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          statusCode: newAction.status,
          message: newAction.message,
        },
      };
    case ORDER_HELP_ACTIONS_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case ORDER_HELP_ACTIONS_SUCCESS:
      contact = createContactModal(newAction.payload);
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          modal: contact,
        },
      };
    case ORDER_HELP_ACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          statusCode: newAction.status,
          message: newAction.message,
        },
      };
    case ORDER_STATUS_WHATSAPP_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case ORDER_STATUS_WHATSAPP_SUCCESS:
      return {
        ...state,
        infoBanner: {
          ...state.infoBanner,
          whatsappOptedIn: true,
        },
        error: null,
        loading: false,
      };
    case ORDER_STATUS_WHATSAPP_FAILURE:
      return {
        ...state,
        error: {
          statusCode: newAction.status,
          message: newAction.message,
        },
        loading: false,
      };
    case SET_INFO_BANNER_MODAL_IS_OPEN:
      return {
        ...state,
        infoBanner: {
          ...state.infoBanner,
          isModalOpen: newAction.payload.isOpen,
        },
      };
    default:
      return { ...state };
  }
}
